
import { BaseIcon } from "components/atoms";
import { iconN } from "assets/icons";

export default {
  name: "NotificationButton",
  components: { BaseIcon },
  props: {
    iconName: { type: String as () => iconN, required: true },
    isAnimated: { type: Boolean, default: false },
    hasNotification: { type: Boolean, default: false },
  },
  emits: ["on-click"],
};
